import React, { Component } from 'react';

import Combo from './Combo';

class Email extends Component {
    constructor(props) {
        super(props);
    } 

    render() { 

        const {data, esModificacion} = this.props;
        const {validaCamposEdicion} = data;

        let disablePrepaga = !(data.tiposCuentaDisponibles != "TC" && data.tiposProductoPermitidosModificacion != "TC");
        let disableCredito = !(data.tiposCuentaDisponibles != "TP" && data.tiposProductoPermitidosModificacion != "TP");

        return (  
        <div className='modalEmailInterior'>
            <div className='bottom-separator modalTelefonosEncabezado'>
                {!esModificacion ? <h1>Carga de nueva dirección electrónica</h1> : <h1>Modificación de dirección electrónica</h1>}
                <label onClick={()=>this.props.funcionModalConfirmador("abrir","EMAIL")} className='ti-close clickable'></label>
            </div>
            {validaCamposEdicion.validarRegistros == false && <label className='error' style={{marginLeft: "40px"}}>La dirección electrónica ya se encuentra registrada</label>}
            <div className='modalEmailCuerpo'>

                <Combo modFormato={"comboEmailClienteModif"} validaCamposEdicion={validaCamposEdicion.tipoDireccionElectronica} mensajeErrorValidacion={"Debe ingresar un  tipo de dirección electrónica"} campo={'tipoDireccionElectronica'} titulo={"Tipo de dirección electrónica"} infoData={data.tiposComunicacion} selectCombo={this.props.funcionEdicion} selecciones ={data}/>
                
                <div className={"inputModificacionEmail bottom-separator-marca"}>
                    <label className="label-primary">Dirección electrónica</label>
                    <input maxLength={40} value={data.emailEnEdicion} onChange={(e)=>this.props.funcionEdicion("emailEnEdicion",e.target.value)} placeholder={"ej: mail@mail.com"} type='text'></input>
                    {validaCamposEdicion.email == false && <label className='error'>Debe ingresar una dirección válida</label>}   
                    {validaCamposEdicion.mailRepetidoTP == false && validaCamposEdicion.mailRepetidoTC == true && <label className='error'>El email ya se encuentra registrado para  la cuenta prepaga</label>}   
                    {validaCamposEdicion.mailRepetidoTC == false && validaCamposEdicion.mailRepetidoTP == true && <label className='error'>El email ya se encuentra registrado para  la cuenta crédito</label>}   
                    {validaCamposEdicion.mailRepetidoTC == false && validaCamposEdicion.mailRepetidoTP == false && <label className='error'>El email ya se encuentra registrado para  las cuentas</label>}   
                    {validaCamposEdicion.mailRepetidoSinCuenta == false && <label className='error'>El email ya se encuentra registrado</label>}   
                </div>

                <div className=''>
                    <label className="label-primary">Utilizar para el envío de correspondencia de los productos</label>
                    <div className="contenedorDatosProceso">
                        <div className="inlineListItem2 lg-margin">
                        <div className="contenedorCheckboxTelefono default-checkbox">
                                <input disabled={disablePrepaga} id={"check-tipoProducto-Prepaga"} type="checkbox" checked={data.checkProductoPrepaga} onChange={(e)=>this.props.funcionModificarCheck("checkProductoPrepaga")}  />
                                <label className={"label-primary " +( !disablePrepaga ? "" : "disabledGrey") } htmlFor={"check-tipoProducto-Prepaga"}></label>
                        </div>
                        <label className="label-primary headerConfirmadorDenegar" htmlFor={"check-tipoProducto-Prepaga"}>Prepaga</label>
                        </div>
                        <div className="inlineListItem2 lg-margin">
                        <div className="contenedorCheckboxTelefono default-checkbox">
                                <input disabled={disableCredito} id={"check-tipoProducto-Credito"} type="checkbox" checked={data.checkProductoCredito} onChange={(e)=>this.props.funcionModificarCheck("checkProductoCredito")}  />
                                <label className={"label-primary " +( !disableCredito ? "" : "disabledGrey") } htmlFor={"check-tipoProducto-Credito"}></label>
                            </div>
                            <label className="label-primary headerConfirmadorDenegar" htmlFor={"check-tipoProducto-Credito"}>Crédito</label>
                        </div>
                    </div>
                    {validaCamposEdicion.tipoProducto == false && <label className='error'>Debe seleccionar un tipo de producto</label>}
                </div>
            </div>

            <div className='footerTelefonosModal'>
                <button onClick={()=>this.props.funcionModalConfirmador("abrir","EMAIL")} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>this.props.funcionAceptar("EMAIL",esModificacion)} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default Email;